export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/CM-44157920179b3ab3bef729c3c275b3d1.png";